import React from "react";
import { AuthInfo } from "../models/AuthResponse";
import { IUser } from "../models/IUser";
import AuthService from "../services/AuthService";
import { makeAutoObservable } from "mobx";
import { IChangePasswordViewModel } from "../models/ChangePasswordViewModel";
import LicenceCache from "../components/cache/LicenceCache";


export default class AuthStore {
    storage = {};
    cacheDurations = {};
    user = {} as IUser;
    isAuth = false;
    isLoading = false;
    constructor() {
        makeAutoObservable(this);
    }
    setAuth(isAuth: boolean) {
        this.isAuth = isAuth;
    }
    setUser(user: IUser) {
        this.user = user;
    }
    setIsLoading(isLoading: boolean) {
        this.isLoading = isLoading;
    }

    setAuthInfoAuthStore = (authInfo: AuthInfo) => {
        if (authInfo && authInfo.user && authInfo.user.Id && authInfo.user.Id.length > 0) {
            console.log("setAuthInfoAuthStore.token=" + authInfo.accessToken);
            console.log("setAuthInfoAuthStore.refreshToken=" + authInfo.refreshToken);
            localStorage.setItem("token", authInfo.accessToken);
            localStorage.setItem("refreshToken", authInfo.refreshToken);
//            LicenceCache.setToCache(this, "refreshToken", authInfo.refreshToken, 86400*30);
            this.setAuth(true);
            this.setUser(authInfo.user);
        }
        else {
            console.log("setAuthInfoAuthStore.removeItem(token)");
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            this.setAuth(false);
            this.setUser({} as IUser);
//            LicenceCache.setToCache(this, "refreshToken", "", 0);
            if (this.storage["onAfterLogout"]) {
                this.storage["onAfterLogout"]();
            }
        }
    }


    isAuthorited(): boolean {
        return this.isAuth;
    }




    responseProcess = (responseData, raiseException = false) => {
        if (responseData && responseData.data && responseData.error == null) {
            this.setAuthInfoAuthStore(responseData.data);
        }
        else if (responseData && responseData.error && raiseException) {
            throw Error(responseData.error.text);
        }
        else {
            this.setAuthInfoAuthStore(null);
        }
    }

    async login(email: string, password: string) {
        try {
            const response = await AuthService.login(email, password, this);
            this.responseProcess(response, true);
        }
        catch (e){
            console.log(e);
            throw e;
        }
    }
    async refresh() {
        try {
            const response = await AuthService.refresh(this);
            this.responseProcess(response);
        }
        catch (e) {
            console.log(e);
        }
    }
    async logout() {
        try {
            const response = await AuthService.logout(this);
            this.setAuthInfoAuthStore(null);
        }
        catch (e) {
            console.log(e);
        }
    }
    async checkAuth() {
        this.setIsLoading(true);
        try {
            await this.refresh();
        }
        finally {
            this.setIsLoading(false);
        }
    }

    async editUser(user: IUser) {
        try {
            const response = await AuthService.editUser(user, this);
            this.responseProcess(response, true);
        }
        catch (e) {
            console.log(e);
            throw e;
        }
    }

    async changePassword(changePasswordViewModel: IChangePasswordViewModel) {
        try {
            const response = await AuthService.changePassword(changePasswordViewModel, this);
            this.responseProcess(response, true);
        }
        catch (e) {
            console.log(e);
            throw e;
        }
    }
}
//export const authStore = new AuthStore();
